/**
 * Centralized logging for Activation Flow
 * Ensures consistent log formatting and controls dev/production output
 */

const PREFIX = '[mostly Activation Flow]:';

export const bankingSignupLogger = {
  /**
   * Development-only logs (hidden in production)
   */
  debug: (message: string, ...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`${PREFIX} ${message}`, ...args);
    }
  },

  /**
   * Info logs (shown in all environments)
   * Use only for important state changes
   */
  info: (message: string, ...args: any[]) => {
    console.log(`${PREFIX} ${message}`, ...args);
  },

  /**
   * Warning logs (shown in all environments)
   * Use for unexpected but recoverable situations
   */
  warn: (message: string, ...args: any[]) => {
    console.warn(`${PREFIX} ⚠️ ${message}`, ...args);
  },

  /**
   * Error logs (shown in all environments)
   * Use for actual errors that affect functionality
   */
  error: (message: string, ...args: any[]) => {
    console.error(`${PREFIX} ❌ ${message}`, ...args);
    // TODO: Send to error tracking service (Sentry, etc)
  },

  /**
   * Step transition logs (development only)
   */
  stepTransition: (
    from: string | number,
    to: string | number,
    reason?: string,
  ) => {
    if (process.env.NODE_ENV === 'development') {
      const reasonText = reason ? ` (${reason})` : '';
      console.log(`${PREFIX} Step: ${from} → ${to}${reasonText}`);
    }
  },

  /**
   * Auto-skip logs (development only)
   */
  autoSkip: (fromStep: string, toStep: string, reason: string) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(
        `${PREFIX} ⏩ Auto-skipping ${fromStep} → ${toStep}: ${reason}`,
      );
    }
  },
};
